export default "__VITE_ASSET__d0ea89ee__"